import React from 'react';
import PageTransition from '../components/PageTransition';
import './LegalPages.css';

function PrivacyPolicyPage() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Privacy Policy</h1>
                <p className="effective-date">Effective Date: 24/2/2026</p>

                <section className="legal-section">
                    <p>At Iswaran, we value the trust you place in us when sharing your personal information for your spiritual needs. This Privacy Policy describes how we collect, use, and protect your data.</p>
                </section>

                <section className="legal-section">
                    <h2>Information Collection</h2>
                    <p>We collect personal details such as your name, date of birth, Rasi, Nakshatra, Gothra, address, and contact information to perform Archanas and Poojas on your behalf.</p>
                </section>

                <section className="legal-section">
                    <h2>Use of Data</h2>
                    <p>Your information is used strictly to facilitate temple services, ship Prasadam, and provide updates regarding your bookings.</p>
                </section>

                <section className="legal-section">
                    <h2>Data Security</h2>
                    <p>We use secure encryption and trusted payment gateways (like Razorpay/others) to ensure your financial transactions are safe. We do not store credit/debit card details.</p>
                </section>

                <section className="legal-section">
                    <h2>Third-Party Disclosure</h2>
                    <p>We do not sell or rent your personal information. Data is only shared with logistics partners for Prasadam delivery and relevant temple authorities where necessary.</p>
                </section>
            </div>
        </div>
    );
}

export default PageTransition(PrivacyPolicyPage);
